import { Component, Input } from '@angular/core';

import { TextControlComponent } from '../shared/controls/text-control/text-control.component';

@Component({
  selector   : 'chargify-subscription-control',
  styles: [ require('./chargify.subscription-control.component.scss') ],
  template: require('./chargify.subscription-control.component.html')
})
export class ChargifySubscriptionControlComponent extends TextControlComponent {
  @Input() byYear : string;
  @Input() fee    : string;
  @Input() taxName: string;
  @Input() value  : string;
}
